/** Окно VIP — представление без стора, всё приходит пропсами. */
import { Button, Icon, Panel, WindowShell } from "../kit";
import { Stars } from "../offers";
import { VIP_STARS } from "@newfungame/contracts";
import { useT } from "../../../app";
import "./styles.css";

export interface VipViewProps {
  /** Цена из состояния игрока: она же будет в счёте. */
  stars?: number;
  canPay: boolean;
  busy: boolean;
  onBuy(): void;
  onTelegram(): void;
  onClose(): void;
}

export function VipView({ stars = VIP_STARS, canPay, busy, onBuy, onTelegram, onClose }: VipViewProps) {
  const t = useT();
  return (
    <WindowShell kind="vip" title={t("win.vip.title")}>
      <Panel class="win-vip" testid="vip-perks">
        <span>
          <Icon name="clock" size={24} /> {t("win.vip.noWait")}
        </span>
        <span>
          <Icon name="bolt" size={24} /> {t("win.vip.speed")}
        </span>
        <span>
          <Icon name="star" size={24} /> {t("win.vip.auto")}
        </span>
        <span>
          <Icon name="shield" size={24} /> {t("win.vip.revive")}
        </span>
      </Panel>
      <div class="win-actions">
        {canPay ? (
          <>
            <Button tone="green" onClick={() => !busy && onBuy()} data-testid="vip-buy">
              {t("win.vip.buy")} <Stars n={stars} />
            </Button>
            <p class="win-note">{t("win.vip.terms")}</p>
          </>
        ) : (
          <>
            <Button tone="blue" onClick={onTelegram} data-testid="vip-telegram">
              {t("win.pay.telegram")}
            </Button>
            <p class="win-note">{t("win.pay.telegramNote")}</p>
          </>
        )}
        <Button tone="link" onClick={onClose} data-testid="vip-close">
          {t("win.vip.later")}
        </Button>
      </div>
    </WindowShell>
  );
}
